function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "logo");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("polygon", {
  id: "path-1",
  points: "0 36 48 36 48 0 0 0"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "com-/-left-menu-v2",
  transform: "translate(-21.000000, -31.000000)"
}, React.createElement("g", {
  id: "com-/-left-menu-"
}, React.createElement("g", {
  id: "logo",
  transform: "translate(17.000000, 24.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Clip-4"
}), React.createElement("path", {
  d: "M18.2834046,7 L35.2844493,7 C37.9152821,7 39,9.05646205 39,11.3452107 L39,30 L28.0356681,30 L35.7595264,14.7668403 C36.2629589,13.8539056 36.5669088,12.8850771 36.6007362,11.9002788 C36.6596856,10.1922466 35.2541041,8.93475356 33.5913342,8.93475356 L23.0980997,8.93475356 L25.7169933,14.6613434 L29.1718734,14.6613434 L25.4702517,22.7141865 L18.2834046,7 Z M4,7 L11.244304,7 L21.7636554,30 L14.5188538,30 L4,7 Z",
  id: "Fill-10",
  fill: "#ED1C24",
  mask: "url(#mask-2)"
})))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "39px",
    height: "27px",
    viewBox: "0 0 35 23",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.ebb7c0ce.svg";
export { ForwardRef as ReactComponent };